module.exports = __webpack_public_path__ + "static/capabilities-php-2-3323330146f72684cf080342dabf0404.jpg";